import React, { useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`bg-[#406AFF]/10 text-card-foreground rounded-xl border shadow ${
      className || ""
    }`}
    {...props}
  />
));
Card.displayName = "Card";

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={`p-6 pt-0 ${className || ""}`} {...props} />
));
CardContent.displayName = "CardContent";

const teamMembers = [
  {
    name: "Rohit chadha",
    image: "/rohit-chadha.png",
    role: "COO",
    company: "/flipkart---png-0.png",
    companyAlt: "Flipkart png",
    roleWeight: "font-semibold",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203.png",
    role: "CTO",
    company: "/image-627.png",
    companyAlt: "Image",
    roleWeight: "font-semibold",
  },
  {
    name: "Amit zu",
    image: "/amit-zu.png",
    role: "CPO",
    company: "/images-1.png",
    companyAlt: "Images",
    roleWeight: "font-semibold",
  },
  {
    name: "Rohit raj",
    image: "/rohit-raj.png",
    role: "Co-Founder",
    company: "/flipkart---png-1.png",
    companyAlt: "Flipkart png",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203-1.png",
    role: "CPO",
    company: "/7108c5908b7b11b281201ab72aa8f523-1.png",
    companyAlt: "Img",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203-2.png",
    role: "Director",
    company: "/flipkart---png-0-1.png",
    companyAlt: "Flipkart png",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203-3.png",
    role: "Founder",
    company: "/jupiter---png-0.png",
    companyAlt: "Jupiter png",
    company2: "/payu-india---jpeg-0.png",
    companyAlt2: "Payu india jpeg",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203-4.png",
    role: "Ex CTO",
    company: "/flipkart---png-0-2.png",
    companyAlt: "Flipkart png",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5204.png",
    role: "Co-Founder",
    company: "/upgrad---jpeg-0.png",
    companyAlt: "Upgrad jpeg",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5205.png",
    role: "Ex Product Head",
    company: "/facebook---png-0.png",
    companyAlt: "Facebook png",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5206.png",
    role: "COO",
    company: "/quest-global---jpeg-0.png",
    companyAlt: "Quest global jpeg",
    roleWeight: "font-normal",
  },
  {
    name: "Rectangle",
    image: "/rectangle-5203-5.png",
    role: "Ex India Head",
    company: "/pearson---png-0.png",
    companyAlt: "Pearson png",
    roleWeight: "font-normal",
  },
];


const investors = ["https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%2011000.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322558.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322559.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322560.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322561.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322562.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322565.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322567.png",
"https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/investors/Frame%20427322568.png"
]



const Box = () => {

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex >= investors.length - 1) {
          return 0;
        }
        return prevIndex + 1;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [investors.length]);

  return (
    <div className="w-full">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={8}
        slidesPerView={"auto"}
        loop={true}
        autoplay={true}
        className=""
        speed={5000}
      >
        {investors?.map((img, index) => (
          <SwiperSlide key={index} className="!w-auto">
          
              <img 
                src={img} 
                alt={`Investor ${index + 1}`}
                className="h-[52px] w-auto"
                height={52}
              />
          
          </SwiperSlide>
        ))}
      </Swiper>
  </div>

  );
}

const StatsSection = () => {
  return (
    <div className="flex flex-shrink-0 flex-col items-center justify-start">
      <div
        className="text-center text-[24px] md:text-left md:text-[32px] md:font-bold font-semibold leading-[130%]"
        style={{
          background: "linear-gradient(45deg, #FFFFFF 0%, #F7E394 73%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Backed By Top Investors, Trusted By Millions & Recognised By Top Companies You Love
      </div>
      <div className="mt-6 md:mt-8 w-full overflow-hidden">
        <Box />
      </div>
      <div className="mt-3 grid w-full grid-cols-2 grid-rows-1 gap-3">
        <div className="w-full">
          <img
            alt=""
            src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Frame%20427321754%20(3).png"
            className="h-auto w-full"
          />
        </div>
        <div className="w-full">
          <img
            alt=""
            src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Frame%20427321759%20(3).png"
            className="h-auto w-full"

          />
        </div>
      </div>
      <div className="mt-3 w-full">
        <img
          alt=""
          src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Group%2023215%20(2).webp"
          className="h-auto w-full"
          height={115}
          width={358}
        />
      </div>
    </div>
  );
};

export default StatsSection;
